import * as yup from "yup"
import { emailValidationSchema } from "../RegisterModal/validations/courseREgistrationValidationSchemas"

export const subscribeFormValidationSchema = yup.object().shape({
  email: emailValidationSchema
})
